import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const proofOfPriorCoverage: TaskDefinition = {
  taskName: onboardingTasks.NeedProofOfPriorCoverage,
  config: {
    staffDisplayName: 'Proof of prior auto insurance coverage',
    appcuesModalId: '5251e741-2a75-4e50-b245-5a1cef831dae',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of Prior Coverage',
    account: {
      toastMessage: 'Your proof of prior auto insurance coverage documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed, data, brandName }) => {
        const customerSuffix = data.customer ? ` for ${data.customer}` : '';
        return {
          title: `Proof of prior auto insurance coverage${customerSuffix}`,
          incompleteSubtitle:
            'Avoid losing auto coverage by providing proof that the primary named insured has had continuous auto insurance coverage for 90 days.',
          completedSubtitle: `You have successfully submitted for review the proof of prior auto insurance coverage documents for policy ${affectedPolicies}.`,
          actionLabel: 'Upload proof',
          modalTitle: `Upload your proof of prior auto insurance coverage${customerSuffix}`,
          contentSections: [
            {
              title: 'What documents are accepted?',
              subtitle: 'You can provide either of the following:',
              body: [
                'A current or renewal auto insurance declaration page with the primary named insured listed as a driver',
                'Lexis Nexis report with active dates of coverage showing the primary named insured listed as a driver',
                'Letter of experience showing the primary named insured listed as a driver'
              ],
              isList: true
            },
            {
              title: null,
              subtitle: 'To be considered, the verification documents should also:',
              body: [
                `Be dated within 12 months of the effective date of your ${brandName} policy`,
                "Prove that you've had prior auto insurance coverage for state duration",
                "If you've switched carriers within this timeframe, you may need to upload more than one document to cover the entire timeframe"
              ],
              isList: true
            },
            {
              title: "What if I've been away on military deployment?",
              body: 'Provide a letter from your commanding officer or other official documentation with dates of your deployment.'
            },
            {
              title: 'When do I need to submit these documents?',
              body: `You have ${daysAllowed} days from your policy effective date to turn in the verification listed above. Without these documents, we'll have to remove your auto insurance coverage, and if you have other coverage with ${brandName}, the price of your other policies may increase.`
            }
          ]
        };
      }
    }
  }
};
